import { AntibodiesListView } from 'components/AntibodiesList/AntibodiesListView';
import { DefaultModal } from 'components/Modals/DefaultModal';

export const AntibodiesListModal = ({
  isForSlide,
  isForOrderForm,
  handleAddToOrder,
  handleAddToSlide,
  isAntibodiesListModalOpen,
  handleAntibodiesListModalClose,
}) => (
  <DefaultModal
    open={isAntibodiesListModalOpen}
    onClose={handleAntibodiesListModalClose}
    title="Add Antibodies"
    size="large"
    styles={{ width: '90%' }}
  >
    <AntibodiesListView
      isForOrderForm={isForOrderForm}
      handleAddToOrder={handleAddToOrder}
      isForSlide={isForSlide}
      handleAddToSlide={handleAddToSlide}
    />
  </DefaultModal>
);
